/* WJW59B.12 — mobile display-only fixes.
   1) Initialize each native purchase-proof block independently; earlier
      inline custom Liquid queried only the FIRST document match (problem
      when mobile and LIVE-derived desktop product sections coexist).
   2) Decorate DPO's existing Stock: N labels with WJW sale-red.
   No changes to DPO quantities, prices, product data, or event handlers. */
(function () {
  'use strict';
  var mobile = window.matchMedia('(max-width:749px)');
  var queued = false;

  function fixProof() {
    document.querySelectorAll('.wjw59b-mobile-pdp .purchase-proof[data-product-id]').forEach(function (el) {
      var id = Number(el.getAttribute('data-product-id'));
      var count = 0;
      if (Number.isSafeInteger(id) && id > 0) {
        var seed = id % 1000;
        count = seed > 800 ? 500 : seed > 500 ? 300 : seed > 250 ? 150 : 0;
      }
      var label = el.querySelector('.purchase-proof__count');
      var formatted = count ? String(count) + '+' : '';
      if (label && label.textContent !== formatted) label.textContent = formatted;
      /* A zero/invalid count means no purchase-proof badge at all. */
      var shouldHide = !count || !label;
      if (el.hidden !== shouldHide) el.hidden = shouldHide;
    });
  }

  function decorateStock(table) {
    var walker = document.createTreeWalker(table.tBodies[0] || table,
      NodeFilter.SHOW_TEXT);
    var matched = [];
    var node;
    while ((node = walker.nextNode())) {
      if (!/\bStock\s*:\s*\d+\b/i.test(node.nodeValue || '')) continue;
      if (node.parentElement && node.parentElement.closest('.wjw59b12-stock,script,style')) continue;
      matched.push(node);
    }
    matched.forEach(function (textNode) {
      if (!textNode.parentNode) return;
      var text = textNode.nodeValue || '';
      var pattern = /\bStock\s*:\s*\d+\b/gi;
      var parts = document.createDocumentFragment();
      var last = 0, result;
      while ((result = pattern.exec(text))) {
        if (result.index > last) parts.appendChild(document.createTextNode(text.slice(last,result.index)));
        var stockLabel = document.createElement('span');
        stockLabel.className = 'wjw59b12-stock';
        stockLabel.textContent = result[0];
        parts.appendChild(stockLabel);
        last = pattern.lastIndex;
      }
      if (last < text.length) parts.appendChild(document.createTextNode(text.slice(last)));
      textNode.parentNode.replaceChild(parts,textNode);
    });
  }

  function scan() {
    queued = false;
    if (!mobile.matches) return;
    fixProof();
    document.querySelectorAll('.wjw59b-mobile-pdp #bundle-table, .wjw59b-mobile-pdp #tier-table, #Product-Drawer.active #bundle-table, #Product-Drawer.active #tier-table').forEach(decorateStock);
  }
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(scan);
  }
  function boot() {
    /* DPO may replace table rows after quantity changes or when the Quick
       Shop drawer opens; respond only to child-list changes, not keystrokes. */
    new MutationObserver(function (changes) {
      if (changes.some(function (c) { return c.type === 'childList'; })) schedule();
    }).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load',schedule);
    if (mobile.addEventListener) mobile.addEventListener('change',schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
